// 5. INSTITUIÇÃO - PROFISSIONAIS DE SEGURAÇA PÚBLILCA
const instituicao = document.getElementById("grafico__instituicao_psp");
if (instituicao) {
	new Chart(instituicao, {
		type: "doughnut",
		plugins: [ChartDataLabels],
		data: {
			labels: [
				"GCM           ",
				"PC           ",
				"PF           ",
				"PM           ",
				"PRF           ",
			],
			datasets: [
				{
					data: [4, 28, 9, 56, 3],
					backgroundColor: [
						"#aecc53",
						"#dce168",
						"#68bfac",
						"#c0bfa3",
						"#959c64",
					],
					hoverBackgroundColor: [
						"#aecc53",
						"#dce168",
						"#68bfac",
						"#c0bfa3",
						"#959c64",
					],
					borderWidth: 0,
					cutout: "55%",
				},
			],
		},
		options: {
			aspectRatio: 1.5 / 1,
			layout: {
				padding: {
					right: 25,
					top: 20,
				},
			},
			plugins: {
				title: {
					display: false,
					text: ["INSTITUIÇÃO - PROFISSIONAIS", "DA SEGURANÇA PÚBLICA"],
					color: "black",
					padding: {
						bottom: 30,
					},
					font: {
						family: "'proxima-nova', sans-serif",
						size: 20,
						weight: "bold",
					},
				},
				datalabels: {
					align: function (ctx) {
						var value = ctx.dataset.data[ctx.dataIndex];
						if (value < 6) {
							return "end";
						} else {
							return "center";
						}
					},
					offset: -2,
					anchor: function (ctx) {
						var value = ctx.dataset.data[ctx.dataIndex];
						if (value < 6) {
							return "end";
						} else {
							return "center";
						}
					},
					labels: {
						value: {
							font: {
								family: "'proxima-nova', sans-serif",
								size: 18,
								weight: "bold",
							},
							color: "black",
						},
					},
					formatter: function (value, context) {
						return value + "%";
					},
				},
				legend: {
					onClick: () => {},
					position: "right",
					labels: {
						padding: 16,
						usePointStyle: true,
						pointStyle: "circle",
						font: {
							size: function(){
								if (window.innerWidth <= 768) {
									return 13;
								} else {
									return 16;
								}
							},
							family: "'proxima-nova', sans-serif",
						},
					},
				},
				tooltip: {
					enabled: false,
				},
			},
		},
	});
}
